import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from "@angular/common/http";
import { Observable } from "rxjs";

import { environment } from "../../environments/environment";
import { AuthenticationService } from './authentication.service';
import { LocalStorageService, LocalStorageKeyOptions } from './local-storage.service';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AppSettings } from '../shared/App-Settings';

@Injectable()

// @Injectable({
//   providedIn: 'root'
// })
export class InterceptorService implements HttpInterceptor {

  constructor(private authenticationService: AuthenticationService, private local: LocalStorageService, private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // add auth header with jwt if user is logged in and request is to api url
    const currentUser = this.authenticationService.currentUserValue;
    const isLoggedIn = currentUser && currentUser.token;    
    const isApiUrl = req.url.startsWith(AppSettings.API_BASE_URL);
    if (isLoggedIn && isApiUrl) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.token}`
        }
      });
    }

    return next.handle(req).pipe(tap(() => { },
      (err: any) => {        
        if (err instanceof HttpErrorResponse) {
          if (err.status !== 401) {
            return;
          }
          this.router.navigate(['login']);
          /*
          this.authenticationService.RefreshToken().subscribe(res => {
            return;
          }, (err) => {
            console.log(err);
            this.router.navigate(['login']);
          });
*/
        }
      }));
    //return next.handle(req);


  }
}
